import { render, staticRenderFns } from "./GoogleAuthButton.vue?vue&type=template&id=af760b44&scoped=true&"
import script from "./GoogleAuthButton.vue?vue&type=script&lang=js&"
export * from "./GoogleAuthButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleAuthButton.vue?vue&type=style&index=0&id=af760b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af760b44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
